/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of user's progression in a competition
 * @export
 */
export const CompetitionProgressionStatus = {
    RESERVED: 'RESERVED',
    ACTIVE: 'ACTIVE',
    COMPLETED: 'COMPLETED',
    DISQUALIFIED: 'DISQUALIFIED',
    WITHDRAWN: 'WITHDRAWN'
} as const;
export type CompetitionProgressionStatus = typeof CompetitionProgressionStatus[keyof typeof CompetitionProgressionStatus];


export function instanceOfCompetitionProgressionStatus(value: any): boolean {
    for (const key in CompetitionProgressionStatus) {
        if (Object.prototype.hasOwnProperty.call(CompetitionProgressionStatus, key)) {
            if (CompetitionProgressionStatus[key as keyof typeof CompetitionProgressionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompetitionProgressionStatusFromJSON(json: any): CompetitionProgressionStatus {
    return CompetitionProgressionStatusFromJSONTyped(json, false);
}

export function CompetitionProgressionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionProgressionStatus {
    return json as CompetitionProgressionStatus;
}

export function CompetitionProgressionStatusToJSON(value?: CompetitionProgressionStatus | null): any {
    return value as any;
}

export function CompetitionProgressionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): CompetitionProgressionStatus {
    return value as CompetitionProgressionStatus;
}

